import { defineStore } from 'pinia'

export default defineStore({
  id: 'reportFilter',
  persist: true,
  state: () => {
    return {
      cancel: {
        date: []
      },
      customer: {
        date: [],
        sort: '' as number | string
      },
      order: {
        date: [],
        sort: '' as number | string
      },
      partner: {
        date: [],
        sort: '' as number | string
      },
      partnerCancel: {
        date: [],
        sort: '' as number | string
      },
      route: {
        date: [],
        sort: '' as number | string
      },
      status: {
        date: []
      }
    }
  },
  actions: {
    clear: function () {
      this.cancel = {
        date: []
      }
      this.customer = {
        date: [],
        sort: ''
      }
      this.order = {
        date: [],
        sort: ''
      }
      this.partner = {
        date: [],
        sort: ''
      }
      this.partnerCancel = {
        date: [],
        sort: ''
      }
      this.route = {
        date: [],
        sort: ''
      }
      this.status = {
        date: []
      }
    },
    setCancelFilter: function (payload: any) {
      this.cancel = payload || { date: [] }
    },
    setCustomerFilter: function (payload: any) {
      this.customer = payload || { date: [], sort: '' }
    },
    setOrderFilter: function (payload: any) {
      this.order = payload || { date: [], sort: '' }
    },
    setPartnerFilter: function (payload: any) {
      this.partner = payload || { date: [], sort: '' }
    },
    setPartnerCancelFilter: function (payload: any) {
      this.partnerCancel = payload || { date: [], sort: '' }
    },
    setRouteFilter: function (payload: any) {
      this.route = payload || { date: [], sort: '' }
    },
    setStatusFilter: function (payload: any) {
      this.status = payload || { date: [] }
    }
  },
  getters: {
    getCancelFilter: (state: any) => state.cancel,
    getCustomerFilter: (state: any) => state.customer,
    getOrderFilter: (state: any) => state.order,
    getPartnerFilter: (state: any) => state.partner,
    getPartnerCancelFilter: (state: any) => state.partnerCancel,
    getRouteFilter: (state: any) => state.route,
    getStatusFilter: (state: any) => state.status
  }
})
